<template>
  <div class="employees">
    <div class="row">
      <div class="col-12 col-sm-8 text-center text-sm-start">
        <page-title :title="'Medewerkers'" icon="employee"></page-title>
      </div>
      <div class="col-12 col-sm-4  text-center text-sm-end" style="padding-top: 8px; padding-bottom: 8px">
        <button v-if="filterByGroup === true" v-on:click="filterByGroup = false;getEmployees()" class="btn btn-secondary">
          Toon alle
        </button>
        <button v-else v-on:click="filterByGroup = true;getEmployees()" class="btn btn-secondary">
          Toon groep
        </button>
        <span class="d-block d-sm-none" style="padding-top: 12px;"></span>
      </div>
    </div>
    <div v-if="employees" class="row" style="margin-top: 8px">
      <div v-bind:key="employee.id"  v-for="employee in employees" v-on:click="togglePresence(employee)" class="col-sm-6 col-md-6 col-lg-4">
         <employee-list-item :employee="employee" class="item"/>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'
import EmployeeListItem from '@/components/Employee-List-Item'
export default {
  name: 'employees',
  components: {
    PageTitle,
    EmployeeListItem
  },
  computed: {
    employees () {
      return this.$store.getters.employees
    }
  },
  data () {
    return {
      filterByGroup: true
    }
  },
  created () {
    this.$store.dispatch('getEmployees', this.filterByGroup)
  },
  methods: {
    getEmployees () {
      this.$store.dispatch('getEmployees', this.filterByGroup)
    },
    togglePresence (employee) {
      if (employee.presence.present === true) {
        // becomes false
        this.$request.put('/presence/' + employee.presence.id)
        .then(() => {
          this.$store.dispatch('getEmployees', this.filterByGroup)
        })
      } else if (employee.presence.present === false) {
        // becomes true
        this.$request.post('/presence', {
          employee_id: employee.id,
          group_id: this.getOneSelectedGroupId(), // @todo chnage to correct group
        }).then(() => {
          this.$store.dispatch('getEmployees', this.filterByGroup)
        })
      }
    }
  }
}
</script>

<style scoped>
  .item {
    background: rgba(255, 255, 255, 0.5);
    padding: 20px;
    margin-bottom: 10px;
    cursor: pointer;
  }
</style>
